import { render, staticRenderFns } from "./sofyre-comparison.vue?vue&type=template&id=09d693b5&scoped=true&"
import script from "./sofyre-comparison.vue?vue&type=script&lang=js&"
export * from "./sofyre-comparison.vue?vue&type=script&lang=js&"
import style0 from "./sofyre-comparison.vue?vue&type=style&index=0&id=09d693b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d693b5",
  null
  
)

export default component.exports